import { render } from "./PrpModel.vue?vue&type=template&id=3b700b83"
import script from "./PrpModel.vue?vue&type=script&lang=js"
export * from "./PrpModel.vue?vue&type=script&lang=js"

import "./PrpModel.vue?vue&type=style&index=0&id=3b700b83&lang=scss"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__